// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from "@/utils";

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * 文件名过滤器
 * @param {String} string
 */
export function FileNameFilter(item) {
  let tempStr = "";
  if (item) {
    const tempArr = item.split("/");
    tempStr = tempArr[tempArr.length - 1] + "";
  }
  return tempStr;
}

/**
 * 时间过滤器，年月日时分秒---年月日
 * @param {String} string
 */
export function DateYMDHMMToYMDFilter(item) {
  if (item) {
    const date = new Date(item);
    const yy = date.getFullYear();
    let mm = date.getMonth() + 1;
    if (mm < 10) {
      mm = "0" + mm;
    }
    let dd = date.getDate();
    if (dd < 10) {
      dd = "0" + dd;
    }
    return yy + "-" + mm + "-" + dd;
  } else {
    return "";
  }
}

/**
 * 文件路由过滤器
 * @param {String} string
 */
export function FileUrlFilter(item) {
  return process.env.VUE_APP_BASE_URL + item;
}

const chnNumChar = ["零", "首", "二", "三", "四", "五", "六", "七", "八", "九"];
const chnUnitChar = ["", "十", "百", "千"];
export function NumberToChineseFilter(item) {
  var strIns = "";
  var chnStr = "";
  var unitPos = 0;
  var zero = true;
  var section = parseInt(item);
  while (section > 0) {
    var v = section % 10;
    if (v === 0) {
      if (!zero) {
        zero = true;
        chnStr = chnNumChar[v] + chnStr;
      }
    } else {
      zero = false;
      strIns = chnNumChar[v];
      strIns += chnUnitChar[unitPos];
      chnStr = strIns + chnStr;
    }
    unitPos++;
    section = Math.floor(section / 10);
  }
  return chnStr + "次到货";
}
/**
 * 切割获取第一位数据
 * @param {String} string
 */
export function PrNumFilter(item) {
  if (item) {
    var tempArr = item.split("_");
    var tempStr = tempArr[0] + "";
    return tempStr;
  } else {
    return "";
  }
}
/**
 * 消息状态过滤器
 * @param {String} string
 */
export function InformStatusFilter(item) {
  item += ""
  switch (item) {
    case "1":
      return "待发布";
    case "2":
      return "已发布";
    default:
      return "";
  }
}
/**
 * 消息状态过滤器
 * @param {String} string
 */
export function LiveBoardFilter(item) {
  item += ""
  switch (item) {
    case "1":
      return "待直播";
    case "2":
      return "直播中";
    case "3":
      return "已完成";
    case "4":
      return "已作废";
    default:
      return "";
  }
}
